import { render, staticRenderFns } from "./StepAdminSpaRootView.vue?vue&type=template&id=1117708b"
import script from "./StepAdminSpaRootView.vue?vue&type=script&lang=js"
export * from "./StepAdminSpaRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports